<h2 mat-dialog-title>{{editMode ? 'Editar Agenda' : 'Crear Agenda'}}</h2>
<mat-dialog-content>
  <form #form class="example-form">
    <!--descripcion-->
    <mat-form-field appearance="outline" class="example-full-width">
      <mat-label>Descripción</mat-label>
      <textarea [formControl]="description" cdkAutosizeMaxRows="5" cdkAutosizeMinRows="5"
                cdkTextareaAutosize
                matInput maxlength="800" placeholder="Ingrese una Descripción para la agenda..." required></textarea>
      <mat-hint align="start"><strong></strong></mat-hint>
      <mat-hint align="end">{{description.value.length}} / 800</mat-hint>
    </mat-form-field>
    <!--lugar-->
    <mat-form-field appearance="outline" class="example-full-width">
      <mat-label>Lugar</mat-label>
      <input [errorStateMatcher]="matcher" [formControl]="place" matInput maxlength="255"
             placeholder="Ingrese un lugar para la agenda...">
      <mat-hint align="start"><strong></strong></mat-hint>
      <mat-hint align="end">{{place.value.length}} / 255</mat-hint>
      <mat-error *ngIf="place.hasError('whitespace')">Lugar <strong>no permite espacios en blanco como valor</strong></mat-error>
    </mat-form-field>
    <!--hora de inicio-->
    <mat-form-field appearance="outline" class="example-full-width">
      <mat-label>Hora de inicio</mat-label>
      <input [errorStateMatcher]="matcher" [formControl]="startTime" matInput maxlength="255"
             placeholder="Ingrese la hora de inicio para la agenda..."
             required type="time">
      <mat-hint align="start"><strong></strong></mat-hint>
      <mat-hint align="end">{{startTime.value.length}} / 255</mat-hint>
      <mat-error *ngIf="startTime.hasError('required')">Hora de inicio <strong>requerido</strong></mat-error>
    </mat-form-field>
    &nbsp;
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button (click)="onSubmit()" color="primary" mat-raised-button>{{editMode ? 'Guardar' : 'Crear'}}</button>
  <button (click)="onClose()" color="primary" mat-button>Cancelar</button>
</mat-dialog-actions>
